export default __webpack_public_path__ + "static/media/gallery_17.1fe60967.jpg";